// removed by extract-text-webpack-plugin
module.exports = {"product-info":"product-info","favorite-button":"favorite-button","cart-button":"cart-button","product-title":"product-title","product-description":"product-description","conpany-wrap":"conpany-wrap","company-image-wrap":"company-image-wrap","company-name":"company-name","view-info":"view-info","view-info-link":"view-info-link","product-price":"product-price","price":"price","send-request":"send-request","button-white":"button-white","fa":"fa","button-red":"button-red","wrap-button":"wrap-button"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/product/popup-view-detail/product-info/style.scss
// module id = ./components/partials/product/popup-view-detail/product-info/style.scss
// module chunks = 0